module.exports = __webpack_public_path__ + "static/media/three_marker_hover.a255c1fb.svg";